import { render } from "./ProductGroupedOptionField.vue?vue&type=template&id=08b19232"
import script from "./ProductGroupedOptionField.vue?vue&type=script&lang=js"
export * from "./ProductGroupedOptionField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__